import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[tcmVar]',
    exportAs: 'tcmVar',
    standalone: false
})
export class TcmVarDirective {

    @Input('tcmVar') var: any;
}
